import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const BASE_URL = import.meta.env.VITE_API_URL;

export const SALES_TOKEN =
  "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI2NjNkZDM4ZGY5YWNiYzg2MTM4MDIxM2YiLCJpYXQiOjE3NDgzMjc0MDgsImV4cCI6MTc3OTg4NTAwOH0.Tp8sGvLn_P_9WnVkwI9GGtADYB1OIX9kBahxwsjNcHmiPVR6LXIPsDTAsnKY9jkYF01wz9JBSsml1fwqRVF13Q";

export const CAS_TOKEN =
  "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI2N2I4MDJhNWRjMmJhNTY3ZWIzZTljMGMiLCJpYXQiOjE3NDAxMTM2NTEsImV4cCI6MTc3MTY3MTI1MX0.wNOb3FqusynJniEhm8LNdl3GGVHChcfWo8trnebQPIPKeXmYbbV6ytRwbZcHpDoEyS5-chl-mKll_AkRZnMb7Q";

export const API_BASE_URL = "https://service.edencaremedical.com/demo/api/v1";
